import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ModalEdgeCloseBtn = styled(Button)`
  position: sticky;
  top: 0;
  z-index: 5;
  padding: 8px 0 12px 0;
  text-align: center;
  width: 100%;
  background-color: #fff;

  &::before {
    content: '';
    display: inline-block;
    width: 38px;
    height: 5px;
    border-radius: 8px;
    background-color: #eee;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('8 0 12 0')};

    &::before {
      width: ${mixin.pxToVw('38')};
      height: ${mixin.pxToVw('5')};
      border-radius: ${mixin.pxToVw('8')};
    }
  }
`;
